import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import ProfessionalProfile from "../../(User)Profile_Final/index.js";
import Mo3tiSalaryPage from "../../(User)salary_Final/index.js";
import Mo3tiAttendancePage from "../../(User)attendance_page/index.js";
import Mo3tiDocumentsPage from "../../(User)SelfService/index.js";
import Calendar from '../../(All) Calendar/index.jsx';
import Mo3tiLeavePage from "../../(User)leave_Managment/index.js";
import Mo3tiSettingsPage from "../../(All) settings/index.js";
import MessengerPage from "../../(All) messenger/MessengerPage.jsx";
import EscalationPage from "../../(User)EscalationComplaints/index.jsx";
import GroupsManagement from "../../(user) GroupsManagement/index.jsx";
import LocationGuard from "../components/LocationGuard.jsx";

const UserRoutes = ({ pageProps, isPrivateMessagingEnabled, toggleTheme, userLocation, locationError, t }) => (
  <Routes>
    <Route path="/" element={<ProfessionalProfile />} />
    <Route path="/professionalProfile" element={<ProfessionalProfile />} />
    <Route path="/salary" element={<Mo3tiSalaryPage {...pageProps} />} />
    <Route path="/escalation" element={<EscalationPage {...pageProps} />} />
    <Route path="/groups" element={<GroupsManagement />} />
    <Route path="/attendance" element={<Mo3tiAttendancePage {...pageProps} />} />
    <Route path="/employee-services" element={<Mo3tiDocumentsPage {...pageProps} />} />
    <Route path="/calendar" element={<Calendar {...pageProps} />} />
    <Route
      path="/messages"
      element={
        isPrivateMessagingEnabled ? (
            <MessengerPage />
        ) : (
          <Navigate to="/userprofile" replace />
        )
      }
    />
    <Route path="/leave-management" element={<Mo3tiLeavePage {...pageProps} />} />
    <Route path="/settings" element={<Mo3tiSettingsPage {...pageProps} toggleTheme={toggleTheme} />} />
    <Route path="*" element={<Navigate to="/userprofile/professionalProfile" replace />} />
  </Routes>
);

export default UserRoutes;